/**
 * Get the Save & Compare API URL.
 *
 * Priority order:
 * 1. Development fallback URL for local
 * 2. Goto current root domain - Apache proxy pass to Save & Compare api
 */

import { isLocal } from './utils'

export const saveApiUrl = (): string => {
  // Development fallback
  if (isLocal()) {
    return process.env.SAVE_AND_COMPARE_API_URL || ''
  }

  return '/api/save'
}
